import PropTypes from 'prop-types';

export default function CheckIcon({ height = 180, width = 180, fill = '#027F5C' }) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 179 180" fill="none">
            <path d="M89.4998 26.4321C54.4873 26.4321 26.104 54.8154 26.104 89.828C26.104 124.84 54.4873 153.224 89.4998 153.224C124.512 153.224 152.896 124.84 152.896 89.828C152.896 82.9253 151.793 76.2799 149.753 70.0587L158.456 61.3555C162.082 70.1287 164.083 79.7443 164.083 89.828C164.083 131.019 130.691 164.411 89.4998 164.411C48.3086 164.411 14.9165 131.019 14.9165 89.828C14.9165 48.6367 48.3086 15.2446 89.4998 15.2446C108.319 15.2446 125.51 22.2146 138.632 33.7139L130.702 41.645C119.62 32.1606 105.229 26.4321 89.4998 26.4321Z" fill={fill}/>
            <path d="M152.775 48.9466C154.96 46.7621 154.96 43.2203 152.775 41.0359C150.59 38.8513 147.049 38.8513 144.865 41.0359L88.9764 96.924L63.969 71.9169C61.7845 69.7324 58.2427 69.7324 56.0583 71.917C53.8738 74.1014 53.8738 77.6435 56.0583 79.828L85.0212 108.79C87.2058 110.975 90.747 110.975 92.9315 108.79L152.775 48.9466Z" fill={fill}/>
        </svg>
    );
}

CheckIcon.propTypes = {
    height: PropTypes.number,
    width: PropTypes.number,
    fill: PropTypes.string
};   